import axios, { AxiosInstance, AxiosResponse } from 'axios'
import { appConfig } from '../services/app-config'
import { authStore } from '../store/modules/auth.store'
import { HttpStatus } from '../models/enums'
import router from '../router'

class HttpClient {
  private static instance: HttpClient
  public axios: AxiosInstance

  private constructor() {
    this.axios = axios.create({
      baseURL: appConfig.apiUrl,
      withCredentials: true,
      paramsSerializer: params => {
        return Object.entries(params)
          .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
          .join('&')
      }
    })

    this.initializeResponseInterceptor()
  }

  public static get client(): HttpClient {
    if (!this.instance) {
      this.instance = new HttpClient()
    }
    return this.instance
  }

  private initializeResponseInterceptor() {
    this.axios.interceptors.response.use(
      (response: AxiosResponse) => response,
      async error => {
        const status = error?.response?.status
        const originalRequest = error.config

        if (
          status !== HttpStatus.UNAUTHORIZED ||
          originalRequest?.url?.includes('auth/login')
        ) {
          return Promise.reject(error)
        }

        if (status === HttpStatus.UNAUTHORIZED) {
          if (originalRequest?.url?.includes('auth/refreshAccessToken')) {
            console.warn('Unauthorized')
            authStore.logout()
            router.push({ name: 'login' })
            return Promise.reject(error)
          }

          if (!originalRequest._retry) {
            originalRequest._retry = true
            await authStore.refreshAccessToken()
            return this.axios(originalRequest)
          }
        }

        return Promise.reject(error)
      }
    )
  }
}

export const httpClient = HttpClient.client.axios